import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Info from './Info';
import Scrollchor from 'react-scrollchor';
import { formatNumber } from '../../../../utils/helpers';
import 'react-accessible-accordion/dist/fancy-example.css';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import JwPagination from 'jw-react-pagination';
import LazyBg from '../../../UI/LazyImage/LazyBg';
import './List.css';

class SpacesMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageOfItems: [],
        };
    }

    onChangePage = (pageOfItems) => {
        this.setState({ pageOfItems });
    }

    onPaginationClick = () => {
        this.propertyId.simulateClick();
    }

    render() {
        const { property, filters, spacesInfo } = this.props;
        const availableSqFtMin = filters.availableSqFt && filters.availableSqFt.value.min;
        const availableSqFtMax = filters.availableSqFt && filters.availableSqFt.value.max;
        const imgUrl = property.thumbnail
            ? `${process.env.RAZZLE_ASSET_URL}${property.thumbnail}`
            : '/thumbnail';
        const customLabels = {
            previous: '\u276E',
            next: '\u276F',
        };
        const propertyId = property._id;
        
        return (
            <div>
                <div className='property-card'>
                    <Link to={`/office/${property.slug}`} className="property-link">
                        <div className="property-title">{property.name}</div>
                        <div className="property-subtitle">{`${property.city}, ${(property.state==='BRITISH COLUMBIA') ? 'BC' : property.state.substring(0, 2)}`}</div>
                    </Link>
                    <div className="columns vertical-align is-mobile">
                        <div className="property-image-info-wrapper">
                            <div className="column is-3-tablet">
                                <Link to={`/office/${property.slug}`}>
                                    <LazyBg src={imgUrl} className="lazy-image property-image image is-1by1" />
                                </Link>
                            </div>
                            <div className="column is-offset-1-tablet">
                                <Info property={property} filters={filters} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-wrapper" id={propertyId} style={{ borderBottom: '0.0625rem solid #e3e3e5', paddingTop: '20px' }}>
                        {/* <Accordion allowZeroExpanded>
                            <Scrollchor ref={ref => (this.propertyId = ref)} to={propertyId} disableHistory={true} animate={{ duration: 250, offset: -52 }} />
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        <div>Availabilities</div>
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {this.state.pageOfItems.map(name =>
                                        <div key={name.id} className="space-wrapper">
                                            <div className="columns is-mobile">
                                                <div className="column is-offset-1-mobile is-offset-4-tablet">
                                                    <div className="space-info-wrapper">
                                                        <div className="space-info-title">Address</div>
                                                        <div className="space-info">{name.street_address}</div>
                                                    </div>
                                                    <div className="space-info-wrapper">
                                                        <div className="space-info-title">Floor</div>
                                                        <div className="space-info">{name.floor}</div>
                                                    </div>
                                                    <div className="space-info-wrapper">
                                                        <div className="space-info-title">Suite</div>
                                                        <div className="space-info">{name.suite}</div>
                                                    </div>
                                                    <div className="space-info-wrapper">
                                                        <div className="space-info-title">SQ. FT.</div>
                                                        <div className={`space-info 
                                                            ${name.space_available >= availableSqFtMin && name.space_available <= availableSqFtMax && filters.availableSqFt ? 'active' : ''}
                                                            ${name.space_available >= 100000 && availableSqFtMax >= 100000 ? 'active' : ''}`}>
                                                            {formatNumber(name.space_available)}
                                                        </div>
                                                    </div>
                                                    <div className="space-info-wrapper">
                                                        <div className="space-info-title">Max Contiguous</div>
                                                        <div className={`space-info
                                                            ${name.maximum_contiguous >= availableSqFtMin && name.maximum_contiguous <= availableSqFtMax && filters.availableSqFt ? 'active' : ''}
                                                            ${name.maximum_contiguous >= 100000 && availableSqFtMax >= 100000 ? 'active' : ''}`}>
                                                            {formatNumber(name.maximum_contiguous)}
                                                        </div>
                                                    </div>
                                                    <div className="space-info-wrapper">
                                                        <div className="space-info-title">Min. Divisible</div>
                                                        <div className={`space-info 
                                                            ${name.minimum_divisible >= availableSqFtMin && name.minimum_divisible <= availableSqFtMax && filters.availableSqFt ? 'active' : ''}
                                                            ${name.minimum_divisible >= 100000 && availableSqFtMax >= 100000 ? 'active' : ''}`}>
                                                            {formatNumber(name.minimum_divisible)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {name.floor_plans[0] ?
                                                <a href={`${name.floor_plans}`} target="_blank" rel="noopener noreferrer" className="space-info-floorplan">Download Floorplan</a>
                                                : ''
                                            }
                                        </div>
                                    )}
                                    <div className="pagination-click-wrapper" role='link' tabIndex='-1' onKeyUp={() => this.onPaginationClick(propertyId)} onClick={() => this.onPaginationClick(propertyId)}>
                                        <JwPagination pageSize={4} items={spacesInfo} onChangePage={this.onChangePage} labels={(this.props.spacesInfo.length > 40) && customLabels} />
                                    </div>
                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion> */}
                </div>
            </div>
        );
    }
}

SpacesMobile.propTypes = {
    property: PropTypes.shape({
        name: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        _id: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        spaces: PropTypes.arrayOf(PropTypes.object).isRequired,
        thumbnail: PropTypes.string,
    }).isRequired,
    filters: PropTypes.object,
    spacesInfo: PropTypes.array,
};

export default SpacesMobile;
